declare global {
  interface Array<T> {
    removeFirst(predicate: (value: T, index: number, obj: T[]) => unknown, thisArg?: any): boolean
  }
}

export class Utils {
  public static debounce(callback: () => void, wait = 500) {
    let timeoutId: number
    return () => {
      // console.log("every calls")
      window.clearTimeout(timeoutId)
      timeoutId = window.setTimeout(() => {
        // console.log("debounce called")
        callback()
      }, wait)
    }
  }

  public static isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

  public static formatStringFullText(str: string): string {
    return str
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") //Removing accent
      .replace(/[ \/]/g, "_")
  }

  public static wait$ = (millisecond: number) =>
    new Promise<void>((resolve) => setTimeout(() => resolve(), millisecond))

  static init() {
    Array.prototype.removeFirst = function (predicate: (value: any, index: number, obj: any[]) => unknown) {
      const index = (this as any).findIndex(predicate)
      if (index >= 0) {
        this.splice(index, 1)
        return true
      }
      return false
    }
  }

  public static extractDateIntegerFromString(dateStr: string): number {
    const res = this.extractDateFromString(dateStr)
    return res.year * 1000 + res.month * 100 + res.day
  }

  public static extractDateFromString(dateString: string): { year: number; month: number; day: number } {
    const month = {
      janvier: 1,
      janv: 1,
      jan: 1,
      février: 2,
      fév: 2,
      févr: 2,
      fev: 2,
      mars: 3,
      mar: 3,
      avril: 4,
      avr: 4,
      mai: 5,
      juin: 6,
      juil: 7,
      juillet: 7,
      août: 8,
      aout: 8,
      aôut: 8,
      septembre: 9,
      sept: 9,
      sép: 9,
      sépt: 9,
      octobre: 10,
      oct: 10,
      novembre: 11,
      nov: 11,
      décembre: 12,
      déc: 12,
      dec: 12,
    } as any

    const regex =
      /(janv|jan|fév|févr|fev|mar|avr|mai|juin|juil|août|aout|aôut|sept|sép|sépt|oct|nov|déc|dec|janvier|février|mars|avril|juillet|août|septembre|octobre|novembre|décembre)[^\d]*(?:\D*(\d{4}))/i
    const match = dateString.match(regex)

    if (!match) return { year: 0, month: 0, day: 0 }

    const monthFound = match[1].toLowerCase()
    const year = parseInt(match[2], 10)

    const matches = dateString.match(/\b\d{1,2}\b/g)

    const day = matches && matches.length > 0 ? +matches[0] : 1

    // console.log("extractDateFromString", dateString, year, month[monthFound] || null, day)

    return {
      year,
      month: month[monthFound] || null,
      day,
    }
  }
}
